import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/app/global-error.jsx");
